import { model as i18n } from '!/i18n'
import { formatFeaturedRowVods } from '$/movies/featured/lib'
import type { VodWithPrice } from '@/interfaces'
import { api, type FeaturedCarouselTyped } from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $featuredCarouselTypeVodFormatted: Store<
  FeaturedCarouselTyped<VodWithPrice>[]
> = combine(
  api.banners.$featuredCarouselTypeVod,
  ssePurchasesModel.$vod,
  i18n.$t,
  (carousels, adjust) => {
    if (carousels?.length === 0) return []
    return carousels.map((category) => {
      return {
        ...category,
        content: formatFeaturedRowVods(category.content, adjust),
      } as FeaturedCarouselTyped<VodWithPrice>
    })
  }
)

export const $featuredCarouselVodTitle: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('movies_featured')
)
